exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 270
// module chunks = 0